import { Log } from "../utils";
import { getFileExtension, isNullOrEmpty } from "../utils/string";
import { AppModule as CoreAppModule } from "./../core/AppModule";
export class AppModule extends CoreAppModule {
    get moduleId() {
        return (AppModule.MODULE_KEY);
    }
    get articleManager() {
        return (this.mArticleManager);
    }
    constructor(pArticleManager) {
        super();
        this.mArticleManager = pArticleManager;
    }
    clearDocumentData() {
        this.mArticleManager._clear();
    }
    async loadDocumentData(pContext, pData) {
        //get obk from document
        const tBuffer = await pContext.getResource("project.obk", true);
        const tSession = this.mArticleManager.session;
        if (tSession.isValid) {
            //upload to eaiws and load session
            const tBlob = new Blob([tBuffer]);
            const tUrl = await tSession.uploadFile("Project", tBlob);
            if (isNullOrEmpty(tUrl))
                throw new Error("Failed to upload obk.");
            await tSession.session.loadSession(tUrl);
            await tSession.deleteFile(tUrl);
        }
        //load catalog images
        if (pData != null) {
            await this.loadCatalogImages(pContext, pData);
        }
    }
    async saveDocumentData(pContext, pOptions) {
        if (pContext == null)
            return (null);
        if (pOptions.embedAppModuleResources) {
            const tModuleData = {};
            //download obk and add it to the document, this will also synchronize the session
            const tUrl = await this.mArticleManager.saveToObk(false);
            if (isNullOrEmpty(tUrl))
                throw new Error("Failed to get obk url.");
            await pContext.addResourceFromUrl(tUrl, "project.obk", true, false);
            //save catalog images
            tModuleData.catalogImages = await this.saveCatalogImages(pContext);
            return (tModuleData);
        }
        else
            return (null); //no other data
    }
    //// internal //////////////////////////////////////////////////////////////////////////////
    /** @internal */
    static _GetCatalogImageIndex(pImageId, pContext) {
        if (isNullOrEmpty(pImageId) || pContext == null)
            return (null);
        const tMap = pContext.customState.getData(AppModule.MODULE_KEY, AppModule.STATE_CATALOGIMG_INDEX_MAP);
        if (tMap == null)
            return (null);
        return (tMap.get(pImageId));
    }
    /** @internal */
    static _GetCatalogImageByIndex(pIndex, pContext) {
        if (pIndex == null || pContext == null)
            return (null);
        const tArray = pContext.customState.getData(AppModule.MODULE_KEY, AppModule.STATE_CATALOGIMG_INDEX_ARRAY);
        if (tArray == null)
            return (null);
        return (tArray[pIndex]);
    }
    async saveCatalogImages(pContext) {
        //collect all image ids
        const tIdSet = new Set();
        const tMainArticles = this.mArticleManager.getAllMainArticles();
        for (const tArticle of tMainArticles) {
            if (tArticle.basketId != null) {
                tIdSet.add(tArticle._getCatalogImageId(tArticle.basketId));
                const tSubArticles = tArticle.getSubArticles(false);
                for (const tSubArticle of tSubArticles) {
                    if (tSubArticle.basketId != null)
                        tIdSet.add(tArticle._getCatalogImageId(tSubArticle.basketId));
                }
            }
        }
        //embed images
        const tCatalogImages = new Array();
        const tIndexMap = new Map();
        const tIds = tIdSet.values();
        let tIter = tIds.next();
        while (!tIter.done) {
            const tId = tIter.value;
            const tImage = this.mArticleManager._getCatalogImageFromCache(tId);
            if (tImage != null && tId != null) {
                const tPath = this.getCatalogImageResourcePath(tId, tImage.name);
                await pContext.addResource(tImage.data, tPath, false);
                tIndexMap.set(tId, tCatalogImages.length);
                tCatalogImages.push({
                    id: tId,
                    name: tImage.name
                });
            }
            tIter = tIds.next();
        }
        pContext.customState.setData(AppModule.MODULE_KEY, AppModule.STATE_CATALOGIMG_INDEX_MAP, tIndexMap);
        return (tCatalogImages);
    }
    async loadCatalogImages(pContext, pData) {
        if (pData == null || pData.catalogImages == null)
            return;
        const tIndexArray = new Array();
        for (const tIOCatImg of pData.catalogImages) {
            try {
                tIndexArray.push(tIOCatImg.id);
                const tPath = this.getCatalogImageResourcePath(tIOCatImg.id, tIOCatImg.name);
                const tData = await pContext.getResource(tPath, true);
                if (tData != null)
                    this.mArticleManager._addCatalogImageToCache(tIOCatImg.id, {
                        data: tData,
                        name: tIOCatImg.name
                    });
            }
            catch (pError) {
                Log.error("Failed to load catalog image " + tIOCatImg.id, pError);
            }
        }
        pContext.customState.setData(AppModule.MODULE_KEY, AppModule.STATE_CATALOGIMG_INDEX_ARRAY, tIndexArray);
    }
    getCatalogImageResourcePath(pId, pName) {
        return ("catalogimages/" + pId + getFileExtension(pName).toLowerCase());
    }
}
AppModule.MODULE_KEY = "egr.wcf.cf";
//// private ///////////////////////////////////////////////////////////////////////////////
AppModule.STATE_CATALOGIMG_INDEX_MAP = "catalogImgIndexMap";
AppModule.STATE_CATALOGIMG_INDEX_ARRAY = "IndexCatalogImgArray";
